export default {
  AIwriter_embed_html: 'HTML visualization',
  AIwriter_embed_backtest_results: 'Backtest results',
  AIwriter_embed_cards: 'Article cards',
  AIwriter_embed_cards_hint: 'Article cards placeholder. Full display requires the article’s extended card data.',

  AIwriter_embed_visualization: 'Data visualization',
  AIwriter_embed_stock: 'Stock assessment',
  AIwriter_embed_technology: 'Technical analysis',
  AIwriter_embed_funds: 'Fund flows',
  AIwriter_embed_analyst: 'Analyst ratings',
  AIwriter_embed_fundamentals: 'Fundamentals',
  AIwriter_embed_prediction: 'Prediction market',
  AIwriter_embed_aime: 'Ask Aime',
  AIwriter_embed_iframe: 'Embedded content',
  AIwriter_embed_hint: 'This component and its settings are saved with the article. Open Preview to view it.',

  AIwriter_backtest_title: 'Quick Backtesting Tool',
  AIwriter_backtest_hint: 'Backtesting block. Open Preview to view the interactive tool.',
  AIwriter_Tone: 'Tone',
  AIwriter_formal: 'Formal',
  AIwriter_informal: 'Informal',
  AIwriter_words: 'Words',
  AIwriter_new: 'Create New',
  AIwriter_Untitled: 'Untitled',
  AIwriter_welcomemessage: 'Start your writing here...',
  AIwriter_typeprompt: 'Type anything here',
  AIwriter_airewriting: 'AI rewriting',
  AIwriter_publish: 'Publish',
  AIwriter_save: 'Save',
  AIwriter_logowords: 'EchoWriter',
  AIwriter_delete: 'Delete ',
  AIwriter_delete_draft: 'Delete this draft?',
  AIwriter_deleteconfirm: 'If you choose to proceed, this draft will be permanently deleted.',
  AIwriter_cancel: 'Cancel',
  AIwriter_confirm: 'Confirm',
  AIwriter_autosaved: 'Auto saved',
  AIwriter_aisearch: 'AI Research',
  AIwriter_askprompt: 'Ask anything below...',
  AIwriter_askanything: 'Ask anything...',
  AIwriter_answer: 'Answer',
  AIwriter_decoration: 'Refine Article',
  AIwriter_image: 'AI Image',
  AIwriter_link: 'Link',
  AIwriter_stockcode: 'Stock code',
  AIwriter_settings: 'Settings',
  AIwriter_unlimited: 'Unlimited',
  AIwriter_results: 'Results',
  AIwriter_replace: 'Replace',
  AIwriter_publishinfo: 'Publish Information',
  AIwriter_coverpage: 'Cover Page',
  AIwriter_coverprompt: 'Click or drag to upload image',
  AIwriter_publishchannels: 'Publish Channels',
  AIwriter_apps: 'Apps',
  AIwriter_terminal: 'Terminal',
  AIwriter_category: 'Category',
  AIwriter_submit: 'submit',
  AIwriter_close: 'Close',
  AIwriter_preview: 'Preview',
  AIwriter_publishcompleted: 'Publish Completed',
  AIwriter_saving: 'Saving...',
  AIwriter_savedsuccessfully: 'Saved successfully',
  AIwriter_modifyingtone: 'AI is modifying tone',
  AIwriter_stop: 'Stop',
  AIwriter_name: 'Name',
  AIwriter_linkprompt: 'Exclude protocol names such as http://',
  AIwriter_codeprompt: 'Enter the complete stock code',
  AIwriter_codeerrorprompt: 'Incorrect stock code',
  AIwriter_generateoutline: 'AI is generating writing outlines',
  AIwriter_generatelogic: 'AI is generating writing logic',
  AIwriter_retrievedata: 'AI agent is retrieving data',
  AIwriter_analysedata: 'AI agent is analysing data',
  AIwriter_writingparagraph: 'AI agent is writing paragraph',
  AIwriter_writingconcepts: 'Writing Concepts',
  AIwriter_writingcompletion: 'AI writing completed. Click the Generate button after your modification.',
  AIwriter_addnewtitle: 'Add a new title',
  AIwriter_citations: 'Citations',
  AIwriter_aicreation: 'AI Creation',
  AIwriter_login: 'Log in',
  AIwriter_logout: 'Sign out',
  AIwriter_signup: 'Sign up',
  AIwriter_deletefailed: 'Deletion failed',
  AIwriter_generate: 'Generate',
  AIwriter_copy: 'Copy',
  AIwriter_copied: 'Copied',
  AIwriter_regenerate: 'Re-generate',
  AIwriter_searcherrorprompt: 'Sorry, AI search failed. Please try again.',
  AIwriter_searchenterprompt: 'Please enter content on the left first',
  AIwriter_coverimageprompt: 'Please add a cover image.',
  AIwriter_savefailed: 'Save failed',
  AIwriter_selectapplication: 'Please select an application',
  AIwriter_selectterminal: 'Please select a terminal',
  AIwriter_selectcolumn: 'Please select a column',
  AIwriter_picuploadprompt: 'Only JPG/PNG files are allowed for uploading',
  AIwriter_imagesizeprompt: 'The image cannot exceed',
  AIwriter_synfailprompt: 'Real-time synchronization failed',
  AIwriter_details: 'Details',
  AIwriter_datadetails: 'Data details',
  AIwriter_professional: 'Professional',
  AIwriter_casual: 'Casual',
  AIwriter_deletionsuccessful: 'Deleted Successfully',
  AIwriter_abbreviation: 'Abbreviation',
  AIwriter_expandanarticle: 'Expand an article',
  AIwriter_writingrefrainprompt: 'AI is currently writing, please refrain from operating!',
  AIwriter_editor_text: 'Text',
  AIwriter_editor_image_imageurl: 'Image URL',
  AIwriter_editor_image_visit: 'Visit',
  AIwriter_editor_stock_symbol: 'Stock Symbol',
  AIwriter_editor_image_urlcheckmsg: 'Please enter the correct image URL',
  AIwriter_editor_image_linkcheckmsg: 'Please enter the correct link',
  AIwriter_editor_stock_checksourcemsg: 'Enter the source name',
  AIwriter_editor_stock_stockmsg: 'Please enter the stock symbol',
  AIwriter_editor_copy_successmsg: 'Copied Success!',
  AIwriter_editor_copy_failmsg: 'Copied Fail! Please try again.',
  AIwriter_editor_words: 'Words',
  AIwriter_editor_discardmsg: 'Do you want to discard the AI response?',
  AIwriter_expandarticle: 'AI is expanding this article',
  AIwriter_abbreviatearticle: 'AI is abbreviating this article',
  AIwriter_askprompt_msg: 'Ask anything...',
  AIwriter_answerfail_msg: 'Request failed, Please try again. ',
  AIwriter_stopgenerator_msg: 'Generation halted',
  AIwriter_aiwriter_new: '+ New',
  AIwriter_aiwriter_aiwriting: 'AI Writing',
  AIwriter_aiwriter_wordsmith: 'WordSmith',
  AIwriter_aiwriter_aisearch: 'AI Search',
  AIwriter_aiwriter_aime: 'AIme',
  AIwriter_aiwriter_refine: 'Refine Article',
  AIwriter_aiwriter_prompt: 'Prompt',
  AIwriter_aiwriter_know: 'Knowledge Base',
  AIwriter_aiwriter_brain: 'Brainstorming',
  AIwriter_aiwriter_finishing: 'Finishing Article',
  AIwriter_aiwriter_restart: 'Restart',
  AIwriter_aiwriter_next: 'Next',
  AIwriter_aiwriter_tell: 'Tell the AI ​​what you want to write',
  AIwriter_aiwriter_aicreation: 'AI Creation',
  AIwriter_aiwriter_snewswire: '# Searching [Newswire] database',
  AIwriter_aiwriter_saime: '# Searching [Aime] database',
  AIwriter_aiwriter_sfinancials: '# Searching [Financials] database',
  AIwriter_aiwriter_sinternet: '# Searching the [Internet]',
  AIwriter_aiwriter_creatingk: 'Creating knowledge base',
  AIwriter_aiwriter_fromdata: 'From Database',
  AIwriter_aiwriter_yourdata: 'Your Data',
  AIwriter_aiwriter_knowb: 'Knowledge Base completed. Edit or add more content.',
  AIwriter_aiwriter_youcan: 'You can add data here',
  AIwriter_aiwriter_completed: 'Completed. Edit or add more content.',
  AIwriter_aiwriter_aiis: 'AI is brainstorming',
  AIwriter_aiwriter_completdedit: 'Completed. Edit or add more content.',
  AIwriter_aiwriter_addanew: '+ Add a new section',
  AIwriter_aiwriter_writingc: '???? Writing Concepts',
  AIwriter_aiwriter_confirm: 'Confirm',
  AIwriter_aiwriter_cancel: 'Cancel',
  AIwriter_aiwriter_click: 'Click to open menu',
  AIwriter_aiwriter_edit: 'Edit',
  AIwriter_aiwriter_insert: 'Insert Below',
  AIwriter_aiwriter_reorder: 'Reorder',
  AIwriter_aiwriter_delet: 'Delete',
  AIwriter_aiwriter_drag: 'Drag to Reorder',
  AIwriter_aiwriter_aiisint: 'AI is integrating articles',
  AIwriter_aiwriter_stop: 'Stop',
  AIwriter_aiwriter_articlefinished: 'Article finished.',
  AIwriter_aiwriter_replace: 'Replace Left Text',
  AIwriter_aiwriter_aiimage: 'AI Image',
  AIwriter_aiwriter_method1: 'Method 1: Directly type your request in the textbox below',
  AIwriter_aiwriter_method2: 'Method 2: Select and right click the content in the article, and click "Create Image"',
  AIwriter_aiwriter_describe: 'Describe your image',
  AIwriter_aiwriter_clearall: 'Clear all',
  AIwriter_aiwriter_aitools: 'AI Tools',
  AIwriter_aiwriter_createimage: 'Create image',
  AIwriter_aiwriter_dragtoleft: 'Drag to Left',
  AIwriter_aiwriter_copy: 'Copy',
  AIwriter_aiwriter_warning: 'Warning',
  AIwriter_aiwriter_switch: 'Switch to another article will remove all brainstorming content under AI Writing',
  AIwriter_aiwriter_areyousure: 'Are you sure to remove this content and all associated data?',
  AIwriter_aiwriter_askanything: 'Ask anything below....',
  AIwriter_aiwriter_answer: 'Answer',
  AIwriter_aiwriter_chart: 'Charts',
  AIwriter_aiwriter_source: 'Sources',
  AIwriter_aiwriter_viewall: 'View all',
  AIwriter_aiwriter_regenerate: 'Re-generate',
  AIwriter_aiwriter_bodycontent: 'Body content',
  AIwriter_generatingout: 'Generating outline. You can edit once completed.',
  AIwriter_processing2: 'Processing',
  AIwriter_enterthetext: 'Enter the text',
  AIwriter_pressspace: 'Press Space to Open AI Writing / Enter a Title',
  AIwriter_noaccess: 'No Access to This Page',
  AIwriter_Attitude: 'Attitude',
  AIwriter_Bearish: 'Bearish',
  AIwriter_Bullish: 'Bullish',
  AIwriter_Neutral: 'Neutral',
  AIwriter_Articled: 'Article does not exist',
  AIwriter_expens: 'Expansion',
  AIwriter_AITools: 'AI Tools',
  AIwriter_freeacc: 'Free account limits to 10 trials on AI Tools.',
  AIwriter_gotit: 'Got it.',
  AIwriter_freeacclit: 'Free Account Limit Reached.',
  AIwriter_freeacccan: 'Free account can use up to 10 trials for image, ai writing, AIME, or other AI Tools.Please upgrade for more uses.',
  AIwriter_aimeq: 'AIME Query Annotation',
  AIwriter_eval: 'Evaluation answer quality',
  AIwriter_impo: 'improve the answer in AI Writer',
  AIwriter_Modifyss: 'Modify',
  AIwriter_annuse: 'Annotated by another user',
  AIwriter_psqpm: 'Please select the quality prior to modification',
  AIwriter_allcomp: 'All completed!',
  AIwriter_yaoamto:
    "You are on annotation mode to improve the quality of AIME's answer. Click on the right to complete the annotation. You can still publish the answer as an article as usual.",
  AIwriter_submt: 'Submit',
  AIwriter_tyaime: 'Thanks for your help to improve AIME!',
  AIwriter_pendiing: 'Pending',
  AIwriter_Annotauery: 'Annotation Query',
  AIwriter_all: 'All',
  AIwriter_Pending: 'Pending',
  AIwriter_AnnotaIME: 'Annotation for AIME',
  AIwriter_Done: 'Done',
  AIwriter_date: 'Date',
  AIwriter_excellent: 'excellent',
  AIwriter_ok: 'ok',
  AIwriter_unacceptable: 'unacceptable',
  AIwriter_Submitted: 'Submitted',
  AIwriter_SubmissionFa: 'Submission Failed',
  AIwriter_author: 'Author',
  AIwriter_pending_cover: 'Pending Uploading Image',
  AIwriter_local_upload: 'Upload Image',
  AIwriter_Image_generation_failed: 'Image generation failed',
  AIwriter_Reload: 'Reload',
  AIwriter_Pending_Generation: 'Pending Generation',
  AIwriter_Upload: 'Upload',
  AIwriter_AI_Image: 'AI Image',
  AIwriter_Preview: 'Preview',
  AIwriter_No_Image: 'No Image',
  AIwriter_Regenerate: 'Regenerate',
  AIwriter_no_content: 'Article content required to generate images',
  'AIwriter_Only FYI': 'Only FYI',
  AIwriter_Edit_Prompt: 'Edit Prompt',
  AIwriter_image_generating: 'Image generating. Please wait...',
  AIwriter_Insert: 'Insert',
  AIwriter_image_is_generating: 'Image Generating',
  AIwriter_Image_Generation_Fail: 'Image Generation Failed',
  AIwriter_Chart_is_Generating: 'Chart Generating',
  AIwriter_Chart_Generating_Fail: 'Chart Generating Failed',
  AIwriter_AI_Character: 'AI Character',
  AIwriter_ai_match_description: 'Find the best author to write your article by our powerful AI',
  AIwriter_ai_manual_pick: 'Manual Pick',
  AIwriter_ai_recommendation_button: 'AI Recomm',
  AIwriter_ai_warning_insert_prompt: 'Please insert your prompt',
  AIwriter_ai_finding_match_author: 'Finding your match',
  AIwriter_ai_pick_button: 'AI Pick',
  AIwriter_ai_manual_change_character: 'Change Character',
  AIwriter_ai_redo_button: 'AI Redo',
  AIwriter_back_button: 'Back',
  AIwriter_use_button: 'Use',
  AIwriter_ai_no_result: 'No Result',
  AIwriter_filter_reset: 'Reset',
  AIwriter_reset_all: 'Reset All',
  AIwriter_insert_table: 'Insert Table',
  AIwriter_delete_table: 'Delete Table',
  AIwriter_merge_cell: 'Merge Cell',
  AIwriter_split_cell: 'Split Cell',
  AIwriter_insert_row_up: 'Insert Row Up',
  AIwriter_insert_row_down: 'Insert Row Down',
  AIwriter_delete_row: 'Delete Row',
  AIwriter_insert_column_left: 'Insert Column Left',
  AIwriter_insert_column_right: 'Insert Column Right',
  AIwriter_delete_column: 'Delete Column',
  AIwriter_video: 'Video',
  AIwriter_video_link: 'Video Link',
  AIwriter_cover: 'Cover',
  AIwriter_cover_image: 'Cover Image',
  AIwriter_cover_link: 'Cover Link',
  dashboard_tab_writer: 'Writer',
  dashboard_tab_review: 'Review',
  // Dashboard Writer page
  dashboard_writer_title: 'Annotation List',
  dashboard_writer_create_list: 'Draft List',
  dashboard_writer_col_recent: 'Recent',
  dashboard_writer_col_createdTime: 'Created time',
  dashboard_writer_col_lastEdit: 'Last edit',
  dashboard_writer_col_status: 'Status',
  dashboard_writer_status_claimable: 'Claimable',
  dashboard_writer_status_claimed: 'Claimed',
  dashboard_writer_status_editing: 'Editing',
  dashboard_writer_status_reviewed: 'Reviewed',
  // Dashboard Review page
  dashboard_review_title: 'Annotation List',
  dashboard_review_col_recent: 'Recent',
  dashboard_review_col_writtenBy: 'Written by',
  dashboard_review_col_reviewedBy: 'Annotated by',
  dashboard_review_col_createdTime: 'Created time',
  dashboard_review_col_lastEdit: 'Last edit',
  dashboard_review_col_status: 'Status',
  dashboard_review_status_claimable: 'Claimable',
  dashboard_review_status_claimed: 'Claimed',
  dashboard_review_status_editing: 'Editing',
  dashboard_review_success_reviewed: 'Article Endorsed',
  dashboard_review_success_published: 'Article Approved',
  dashboard_review_success_dropp: 'Article Deferred',
  dashboard_review_success_abandon: 'Article Rejected',
  dashboard_review_search_placeholder: 'Search',
  dashboard_writer_search_placeholder: 'Search Draft',
  dashboard_review: 'Annotation',
  dashboard_create: 'Create',
  dashboard_podcast: 'Podcast',
  dashboard_review_btn_list: 'Annotation List',
  dashboard_review_btn_in_review: 'In Annotation',
  dashboard_review_btn_history: 'Annotation History',
  review_reviewed: 'Endorse',
  review_published: 'Approve',
  review_drop: 'Defer',
  review_abandon: 'Reject',
  review_reclaim: 'Reclaim',
  review_reclaim_success: 'Reclaimed successfully',
  review_confirm_ok: 'Confirm',
  review_confirm_cancel: 'Cancel',
  review_confirm_message: 'Chinese characters detected. Please make changes on the highlighted parts or confirm to continue',
  review_action_loading: 'Article is still loading. Please try again later.',
  dashboard_review_stats_to_be_reviewed: 'To be Annotated',
  dashboard_review_stats_reviewed_by_me: 'Annotated by me',
  dashboard_review_stats_total_reviewed: 'Total Annotated',
  status_pending_review: 'Pending Review',
  status_in_review: 'In Review',
  status_reviewed: 'Endorsed',
  status_published: 'Approved',
  status_abandoned: 'Rejected',
  AIwriter_claimfailed: 'Article claimed by another user.',
  AIwriter_publishTime: 'Select Publish Time',
  AIwriter_cancleScheduled: 'Cancel Scheduled',
  AIwriter_cancleScheduledSuccess: 'Cancel scheduled successfully',
  AIwriter_cancleScheduledFailed: 'Cancel scheduled failed',
  AIwriter_cancleScheduledconfirm: 'Do you want to cancel the scheduled?',
  dashboard_review_col_scheduledTime: 'Publish time',
  AIwriter_aiwriter_createImage: 'Create AI Image',
  plugin_ai_annotation: 'AI Annotation',
  ai_review_title: 'AI Review',
  ai_review_subtitle: 'Machine review opinion',
  ai_review_group: 'Review group {number}',
  ai_review_empty: 'No AI review data',
  agent_review_title: 'Agent Review',
  agent_review_subtitle: 'DeepSeek agent audit',
  agent_review_empty: 'No agent review data for this article',
  agent_review_summary: 'Summary',
  agent_review_human_review: 'Human review',
  agent_review_location_field: 'Field: {field}',
  agent_review_location_paragraph: 'Paragraph {paragraph}',
  agent_review_verified_value: 'Verified value: {value}',
  agent_review_source: 'Source:',
  agent_review_no_issues: 'No issues found',
  agent_review_expand_finding: 'Expand finding details',
  agent_review_collapse_finding: 'Collapse finding details',
  agent_review_verified: 'Verified',
  agent_review_manual_check: 'Manual check',
  agent_review_feedback: 'Iteration feedback',
  agent_review_feedback_sent_suffix: ' (sent)',
  agent_review_feedback_modal_title: 'Add iteration feedback',
  agent_review_send: 'Send',
  agent_review_cancel: 'Cancel',
  agent_review_feedback_placeholder: 'Describe the issue or suggested improvement...',
  agent_review_feedback_hint: 'This feedback will be sent to Vanish group {groupId}.',
  agent_review_feedback_required: 'Please enter iteration feedback',
  agent_review_feedback_success: 'Iteration feedback sent to group {groupId}',
  agent_review_feedback_error: 'Failed to send. Check your intranet/VPN or gateway configuration and try again.',
  agent_review_message_header: '[Agent Review Iteration Feedback]',
  agent_review_message_article: 'Article: {title}',
  agent_review_message_url: 'URL: {url}',
  agent_review_message_content: 'Feedback:',
  agent_review_category_redline: '🚨 Redline',
  agent_review_category_data: 'A. Data Accuracy',
  agent_review_category_sources: 'B. Sources & Citations',
  agent_review_category_ai_traces: 'C. AI Traces',
  agent_review_category_structure: 'D. Article Structure',
  agent_review_category_title_language: 'E. Title & Language',
  agent_review_category_compliance: 'G. Compliance',
  agent_review_category_other: 'Other',
  agent_review_sop_data_error: 'Data Error',
  agent_review_sop_internal_conflict: 'Internal Data Conflict',
  agent_review_sop_incorrect_comparison: 'Incorrect Comparison',
  agent_review_sop_outdated_data: 'Outdated Data',
  agent_review_sop_entity_information: 'Entity Information',
  agent_review_sop_missing_citation: 'Missing Citation',
  agent_review_sop_citation_mismatch: 'Citation Mismatch',
  agent_review_sop_citation_format: 'Citation Format',
  agent_review_sop_source_quality: 'Source Quality',
  agent_review_sop_ai_trace: 'AI Semantic Trace',
  agent_review_sop_template_repetition: 'Template Repetition',
  agent_review_sop_structure_ratio: 'Structure Ratio',
  agent_review_sop_logical_conflict: 'Logical Conflict',
  agent_review_sop_repeated_content: 'Repeated Content',
  agent_review_sop_title_issue: 'Title Issue',
  agent_review_sop_grammar_issue: 'Grammar Issue',
  agent_review_sop_formatting_issue: 'Formatting Issue',
  agent_review_sop_us_stock_relevance: 'US-stock Relevance',
}
